import React, { Component } from "react";

import { withAppState } from "./../../shared/containers/containerAppState";
import { withAuth } from "./../../shared/containers/containerAuth";

import SideHead from "./../sides/sideHead";

import styles from "./content.module.scss";
import CmsContent from "./CmsContent";
import CarsContent from "./CarsContent";
import ReportsContent from "./ReportsContent";
import ControlContent from "./ControlContent";
import RoutesControlPointsContent from "./RoutesControlPointsContent";
import ModalContainer from "./ModalComponents/ModalContainer";
import PopupNotification from "./PopupNotification/PopupNotification";
import WinterMaintenceContent from "./WinterMaintenceContent/WinterMaintenceContent";
import ModalNotPayment from "./ModalComponents/ModalNotPayment";
import LogisticsContent from "./LogisticsContent";
import { states } from "../../reducers/queriesStates";
import JobRequestContent from "./JobRequestContent";

const PATH = "/Accounts/OAuth2/SignIn";

class Content extends Component {
  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { dataState } = this.props;
    if (dataState === states.READY && prevProps.dataState === states.REQUEST) {
      console.log(prevProps.dataState, dataState);
    }
  }

  render() {
    const { isSideBarOpen, data, dataState } = this.props;
    const { permissions } = data;

    return (
      <div className={styles.wrapper}>
        <SideHead />
        <ModalContainer />
        <ModalNotPayment />
        <PopupNotification />
        {permissions.includes(10001) ? <CmsContent /> : null}
        <CarsContent isSideBarOpen={isSideBarOpen} />
        <JobRequestContent isSideBarOpen={isSideBarOpen} />
        <ReportsContent isSideBarOpen={isSideBarOpen} />
        <ControlContent isSideBarOpen={isSideBarOpen} />
        <RoutesControlPointsContent isSideBarOpen={isSideBarOpen} />
        <LogisticsContent isSideBarOpen={isSideBarOpen} />
        {permissions.includes(36001) ? <WinterMaintenceContent isSideBarOpen={isSideBarOpen} /> : null}
      </div>
    );
  }
}

export default withAppState(withAuth(React.memo(Content)));
